import React from "react";
import "./index.m.css";

export const SupportStrip = ({
  message = "Activating your subscription. This might take a few minutes. If you face any issues, please contact:",
  email = "support@deccanherald.com",
  subject = "I need help with my Subscription",
  body = "Hi, I need help with my subscription.",
}) => {
  const mailtoHref = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <div styleName="supportStrip" role="note" aria-label="Subscription support contact">
      <span styleName="supportMessage">{message}</span>
      <a styleName="supportLink" href={mailtoHref} target="_blank" rel="noopener noreferrer">
        {email}
      </a>
    </div>
  );
};
